import { getNestedValue } from "src/utils/settings";

export const useHeaderFilter = (settings, config, setSetting) => {
  const globalDefault = getNestedValue(settings, ["HeaderFilterDefault"], false);

  const headerFilterSetting = getNestedValue(
    settings,
    ["HeaderFilter", config?.tableName],
    globalDefault,
  );

  const setHeaderFilter = (newHeaderFilter) => {
    setSetting(
      ["HeaderFilter", config?.tableName ?? "UnNamed"],
      newHeaderFilter,
    );
  };

  return { headerFilterSetting, setHeaderFilter };
};
